// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/disengagement-voicebot'

const BaseDisengagementVoicebotAreaRoutes = {
  route: baseRoute,
}

export const DisengagementVoicebotAreaRoutes = transformRoutes(
  BaseDisengagementVoicebotAreaRoutes,
)
